import React from "react";
import { TableRow, TableCell } from "@mui/material";
import CancelIconSVG from "../../../../SharedComponents/assets/icons/svg/CancelIconSVG";
import ArrowNextTableIcon from "../../../assets/icons/svg/ArrowNextTableIconSVG";
import { parseAddressName } from "../../../../SharedComponents/utils/helpers/parseAddressName";


const UserAddressTableRow = ({ address, onSelect, onDelete }) => {
    const { streetNumber, street, city, postalCode } = parseAddressName(address.name);

    const handleEditClick = (e) => {
        e.stopPropagation();
        onSelect()
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        if (window.confirm("Da li ste sigurni da želite da obrišete ovu adresu?")) {
            onDelete(address.id);
        }
    };

    return (
        <TableRow hover style={styles.row}>
            <TableCell>{street}</TableCell>
            <TableCell>{streetNumber}</TableCell>
            <TableCell>{city}</TableCell>
            <TableCell>{postalCode}</TableCell>
            <TableCell onClick={handleEditClick}>
                <ArrowNextTableIcon />
            </TableCell>
            <TableCell onClick={handleDeleteClick}>
                <CancelIconSVG />
            </TableCell>
        </TableRow>
    );
};

export default UserAddressTableRow;

const styles = {
    row: {
        cursor: "pointer",
    },
};
